module.exports = __webpack_public_path__ + "img/help23.ca65664f.png";